import { getMerchantInfo } from './merchantInfo'
import { PROPERTY_HOTEL } from '@merchant-backend/constant'
import { CRAWLER_SOURCE } from '@constant'
/**
 * 是否是新酒店商家
 * 商家的创建时间 大于 9.16号（线上 9.25号） is_new_hotel = 1, 否则不存在这个字段
 */
export const isNewHotel = () => {
  const { is_new_hotel } = getMerchantInfo()
  return is_new_hotel == 1
}
// 是否爬虫商家
export const isCrawlerMerchant = () => {
  const { property_id, source } = getMerchantInfo()
  return property_id === PROPERTY_HOTEL && source === CRAWLER_SOURCE
}
